var React = require('react');

function Gym (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"58.9","y":"62","width":"68.5","height":"17.9","rx":"3","transform":"rotate(90 58.9 62)","stroke":"#000","strokeWidth":"4","key":0}),React.createElement("path",{"d":"M41 76v40h-7a6 6 0 0 1-6-6V82a6 6 0 0 1 6-6h7Z","stroke":"#000","strokeWidth":"4","key":1}),React.createElement("path",{"d":"M152 116V76h7a6 6 0 0 1 6 6v28a6 6 0 0 1-6 6h-7Z","stroke":"#000","strokeWidth":"4","key":2}),React.createElement("rect",{"x":"151.9","y":"62","width":"68.5","height":"17.9","rx":"3","transform":"rotate(90 151.9 62)","stroke":"#000","strokeWidth":"4","key":3}),React.createElement("rect",{"x":"134","y":"104","width":"75","height":"15","rx":"3","transform":"rotate(-180 134 104)","stroke":"#000","strokeWidth":"4","key":4})]);
}

Gym.defaultProps = {"viewBox":"0 0 191 191","width":"191","height":"191","fill":"none"};

module.exports = Gym;

Gym.default = Gym;
